import Toll from './toll'
import CheckApp from './check-app'
import Signalization from './signalization'
import IrrfAutoRetencao from './irrf-auto-retencao'

export default { Toll, CheckApp, Signalization, IrrfAutoRetencao }



// WEBPACK FOOTER //
// ./src/app/pages/DashboardResume/Warning/index.js